module.exports = __webpack_public_path__ + "img/07_freezing_(white).c6f85ce1.svg";